<template>
  <div>
    <Head :title="form.code" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/projects">
        Projects
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ form.code }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input
            v-model="form.ref_area_project_id"
            :error="form.errors.ref_area_project_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Area Project">
            <option
              v-for="areaproject in areaprojects"
              :key="areaproject.id"
              :value="areaproject.id">
              {{ areaproject.code + ' - ' + areaproject.location }}
            </option>
          </select-input>
          <text-input
            v-model="form.code"
            :error="form.errors.code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <text-input
            v-model="form.p_year_start"
            :error="form.errors.p_year_start"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            type="number"
            label="Year Start" />
          <select-input
            v-model="form.p_month_start"
            :error="form.errors.p_month_start"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            label="Month Start">
            <option
              v-for="month in months"
              :key="month.code"
              :value="month.code">
              {{ month.text }}
            </option>
          </select-input>
          <text-input
            v-model="form.p_year_end"
            :error="form.errors.p_year_end"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            type="number"
            label="Year End" />
          <select-input
            v-model="form.p_month_end"
            :error="form.errors.p_month_end"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            label="Month End">
            <option
              v-for="month in months"
              :key="month.code"
              :value="month.code">
              {{ month.text }}
            </option>
          </select-input>
          <textarea-input
            v-model="form.title"
            :error="form.errors.title"
            rows="6"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Title" />
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            rows="6"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
          <select-input
            v-model="form.organization_id"
            :error="form.errors.organization_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Donor">
            <option
              v-for="organization in organizations"
              :key="organization.id"
              :value="organization.id">
              {{ organization.code }}
            </option>
          </select-input>
          <text-input
            v-model="form.concern"
            :error="form.errors.concern"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Concern" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!project.deleted_at"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy">
            Delete Project
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update Project
          </loading-button>
        </div>
      </form>
    </div>
    <h2 class="mt-12 text-2xl font-bold" id="activities">
      Activities
    </h2>
    <div class="flex justify-between my-5 max-w-3xl">
      <search-filter
        v-model="searchform.search"
        :show-dropdown="false"
        class="mr-4 w-full max-w-md"
        @reset="reset" />
      <button class="btn-indigo" @click="createMode = true">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Activity</span>
      </button>
    </div>
    <div class="mt-6 max-w-3xl bg-white rounded shadow overflow-x-auto">
      <table class="whitespace-wrap w-full">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6 w-1/4">
              Activity Name
            </th>
            <th class="pb-4 pt-6 px-6 w-1/4">
              Sector
            </th>
            <th class="pb-4 pt-6 px-6 w-2/4" colspan="2">
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <detail
            v-for="projectActivity in projectActivities.data"
            :key="projectActivity.id"
            :sectors="sectors"
            :editable-mode="projectActivity.editable"
            :project-activity="projectActivity"
            :errors="$page.props.errors"
            @destroy:detail="destroyDetail"
            @edit:detail="editDetail"
            @cancel="cancel('edit')"
            @save="updateDetail" />
          <detail
            v-if="createMode"
            :key="0"
            :editable-mode="createMode"
            :project-activity="editedItem"
            :sectors="sectors"
            :errors="$page.props.errors"
            @cancel="cancel('create')"
            @save="createDetail" />
          <tr v-if="projectActivities.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">
              No activities found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import Detail from '@/Pages/Projects/DetailRow'
import find from 'lodash/find'
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        SearchFilter,
        Detail,
    },
    layout: Layout,
    props: {
        filters: Object,
        project: Object,
        areaprojects: Object,
        projectActivities: Object,
        organizations: Object,
        sectors: Array,
    },
    remember: 'form',
    data () {
        return {
            form: router.form({
                ref_area_project_id: this.project.ref_area_project_id,
                code: this.project.code,
                p_year_start: this.project.p_year_start,
                p_month_start: this.project.p_month_start,
                p_year_end: this.project.p_year_end,
                p_month_end: this.project.p_month_end,
                title: this.project.title,
                description: this.project.description,
                organization_id: this.project.organization_id,
                concern: this.project.concern,
            }),
            searchform: {
                search: this.filters.search,
            },
            months: [
                { code: 1, text: 'JAN' },
                { code: 2, text: 'FEB' },
                { code: 3, text: 'MAR' },
                { code: 4, text: 'APR' },
                { code: 5, text: 'MAY' },
                { code: 6, text: 'JUN' },
                { code: 7, text: 'JUL' },
                { code: 8, text: 'AUG' },
                { code: 9, text: 'SEP' },
                { code: 10, text: 'OCT' },
                { code: 11, text: 'NOV' },
                { code: 12, text: 'DEC' },
            ],
            createMode: false,
            editedItem: {
                id: null,
                name: null,
                description: null,
                editable: false,
            },
            detailKeyRefresh: 0,
        }
    },
    watch: {
        searchform: {
            deep: true,
            handler: throttle(function () {
                router.get('/projects/' + this.project.id + '/edit', pickBy(this.searchform), { preserveState: true, preserveScroll: true })
            }, 150),
        },
    },
    methods: {
        update () {
            this.form.put(`/projects/${this.project.id}`)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this project?')) {
                router.delete(`/projects/${this.project.id}`)
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this project?')) {
                router.put(`/projects/${this.project.id}/restore`)
            }
        },
        reset () {
            this.searchform = mapValues(this.searchform, () => null)
        },
        editDetail (detail) {
            let edited = find(this.projectActivities.data, ['id', detail.id])
            edited.editable = true
        },
        destroyDetail (detailId) {
            router.delete(`/projectactivities/${detailId}`, { preserveScroll: true })
        },
        resetEditedItem () {
            this.editedItem = {
                id: null,
                name: null,
                description: null,
                sector: null,
                editable: false,
            }
            this.createMode = false
        },
        cancel (action) {
            if (action === 'create') this.resetEditedItem()
            if (action === 'edit') router.reload({ only: ['projectActivities'] })
        },
        createDetail (value) {
            const formDetail = router.form({
                project_id: this.project.id,
                name: value.name,
                description: value.description,
                sector_id: value.sector ? value.sector.id : null,
            })

            formDetail.post('/projectactivities', {
                preserveScroll: true,
                onSuccess: () => {
                    this.resetEditedItem()
                },
                onError: () => {
                    this.editedItem = value
                },
            })
        },
        updateDetail (value) {
            const formDetail = router.form({
                name: value.name,
                description: value.description,
                sector_id: value.sector ? value.sector.id : null,
            })

            formDetail.put(`/projectactivities/${value.id}`, {
                preserveScroll: true,
                onError: () => {
                    this.editedItem = value
                },
            })
        },
    },
}
</script>
